import { assistedAffiliationClient } from "./assistedAffiliationClient";
import { getAssistedAffiliationHost } from "./getAssistedAffiliationHost";
import { ApiEnvelope, AssistedAffiliationDraft } from "./types";

// Espeja al endpoint de creación con otro verbo: la identificación viaja en el body, no en la ruta.
const assistedAffiliationDraftEndpoint = "/v1/assisted-affiliation/draft";

/**
 * Guarda los cambios de una solicitud existente.
 * @param draft - El registro COMPLETO. Se manda entero, no solo lo editado, porque el servicio
 * reemplaza el objeto: enviar un subconjunto borraría los campos ausentes.
 * @returns El contenido de `data`, que el servicio devuelve vacío: solo confirma la operación, no
 * responde el registro. Relanza el error para que la pantalla lo traduzca.
 */
export const updateAssistedAffiliationDraftService = async (
  draft: AssistedAffiliationDraft
): Promise<AssistedAffiliationDraft | null> => {
  const host = await getAssistedAffiliationHost();

  const response = await assistedAffiliationClient.put<
    ApiEnvelope<AssistedAffiliationDraft | null>
  >(`${host}${assistedAffiliationDraftEndpoint}`, draft);

  return response.data.data ?? null;
};
